import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, TemplateRef, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, combineLatest, forkJoin, takeUntil, firstValueFrom, take } from 'rxjs';
import { RoutineService } from '../../../services/routines.service';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from 'app/core/directives/directives.module';
import { MatDialog } from '@angular/material/dialog';
import { TypeDevice } from 'app/modules/admin/models/types_devices.types';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { Cluster } from 'app/modules/admin/models/clusters.types';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Division } from 'app/modules/admin/models/divisions.types';
import Swal from 'sweetalert2';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TypeDeviceSummary } from 'app/modules/admin/models/type_device_summary.types';
import { FieldGridComponent } from '@/common/components/field-grid/field-grid.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WebSocketService } from 'app/modules/admin/services/websocket.service';
import { Device } from 'app/modules/admin/models/devices.types';
import { WsResponse } from 'app/modules/admin/models/ws_response.types';
import { RoutineType } from '@/models/routine_types.types';
import { ROUTINE_TYPES } from '@/consts/routine_types.const';
import { ESP_COLOR_AVAILABLES } from '@/consts/esp_color_availables';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CoachDevicesService } from '@/services/coach-devices.service';
import { DeviceAssignmentService } from '../../routine-detonator/services/device-assignment.service';
import { RoutineDetonatorDeviceModalComponent } from '../../routine-detonator/routine-detonator-device-modal.component';
import { DeviceStatus } from 'app/modules/admin/models/devices.types';

@Component({
    selector: 'app-manual',
    templateUrl: './manual.component.html',
    styleUrls: ['./manual.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatOptionModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatTooltipModule,
        DirectivesModule,
        MatButtonToggleModule,
        MatTableModule,
        MatProgressSpinner,
        FieldGridComponent,
        MatCheckboxModule,
        MatMenuModule,
        MatMenuModule
    ],
    providers: [
        DeviceAssignmentService
    ],
    animations: [
        trigger('fadeRoutineChange', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('200ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ]
})
export class ManualComponent implements OnInit, OnDestroy {
    // Control de vista móvil
    mobileView: 'field' | 'config' = 'field';
    deviceIsMd: boolean = false;

    @ViewChild('divisionModal') divisionModal: TemplateRef<any>;
    @ViewChild('table', { static: true }) table: MatTable<any>;

    numCols = 7;
    numRows = 0;

    clusterData$: Cluster[] = [];
    filteredClusterData$: Cluster[] = [];
    //selectedClusterId: number;
    selectedCluster: Cluster;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    typesDevices: TypeDevice[] = [];
    currentRow: number | null = null;
    currentCol: number | null = null;
    tableData: { [key: string]: TypeDeviceSummary } = {};
    routine: { id: number, position: string, g?: number, y?: number, r?: number, time?: number, c?: number, color_id?: number | null }[] = [];
    divisionForm: UntypedFormGroup;
    currentSelectedCell: { row: number, col: number } | null = null;
    selectedDivisions: Division[] = [];
    divisions: Division[] = [];
    displayedColumns: string[] = ['position', 'green', 'yellow', 'red', 'actions'];
    isLoading: boolean = true;
    greenTime: number = 5;
    yellowTime: number = 3;
    redTime: number = 2;
    uuid: string = '';
    devices: Device[] = [];
    routineUuid: string | undefined = undefined;
    typesDevicesForGrid: any = []
    routineTypes: RoutineType[] = ROUTINE_TYPES;
    selectedRoutineType: RoutineType | null = null;
    colorTime: number = 5;
    colorId: number = 0;
    other_devices: string[] = [];
    readonly ESP_COLOR_AVAILABLES = ESP_COLOR_AVAILABLES;

    // Variables para el estado de la conexión WebSocket
    wsConnected: boolean = true;
    connectionFailed: boolean = false;
    devicesStatus: DeviceStatus[] = [];

    // Modal state
    modalPosition: string | null = null;
    modalCurrentDeviceId: number | null = null;
    availableDevices: Device[] = [];

    private readonly CACHE_KEY = 'manualRoutine.config';

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _service: RoutineService,
        private dialog: MatDialog,
        private _formBuilder: UntypedFormBuilder,
        private _webSocketService: WebSocketService,
        private _breakpointObserver: BreakpointObserver,
        private _coachDevicesService: CoachDevicesService,
        private _deviceAssignmentService: DeviceAssignmentService
    ) { }

    get title(): string {
        return 'Rutina manual';
    }

    private saveState(): void {
        const state = {
            selectedClusterId: this.selectedCluster?.id,
            selectedRoutineTypeId: this.selectedRoutineType?.id,
            selectedDivisionIds: this.selectedDivisions.map(d => d.id),
            greenTime: this.greenTime,
            yellowTime: this.yellowTime,
            redTime: this.redTime,
            colorTime: this.colorTime,
            colorId: this.colorId,
            routine: this.routine,
            deviceAssignments: this.selectedCluster?.type_devices?.map(td => ({
                position: td.pivot.position,
                selected_device_id: td.selected_device_id
            })) || []
        };
        console.log('saveState - Saving divisions:', state.selectedDivisionIds);
        localStorage.setItem(this.CACHE_KEY, JSON.stringify(state));
    }

    private loadState(): void {
        const json = localStorage.getItem(this.CACHE_KEY);
        if (!json) return;

        try {
            const state = JSON.parse(json);

            // Restore divisions
            if (state.selectedDivisionIds?.length) {
                this.selectedDivisions = this.divisions.filter(d => state.selectedDivisionIds.includes(d.id));
                const divisionsArray = this.divisionForm.get('divisions') as UntypedFormArray;
                divisionsArray.clear();
                this.selectedDivisions.forEach(d => divisionsArray.push(this._formBuilder.control(d.id)));
            }

            // Restore Cluster
            if (state.selectedClusterId) {
                this.filterClustersByDivisions();
                const cluster = this.filteredClusterData$.find(c => c.id === state.selectedClusterId);
                if (cluster) {
                    this.selectedCluster = cluster;
                    // Restore device assignments
                    if (state.deviceAssignments) {
                        state.deviceAssignments.forEach((assignment: any) => {
                            const td = this.selectedCluster.type_devices.find(t => t.pivot.position === assignment.position);
                            if (td) td.selected_device_id = assignment.selected_device_id;
                        });
                    }
                    this.loadTableData(this.selectedCluster.id);
                }
            }

            // Restore Routine Type
            if (state.selectedRoutineTypeId) {
                this.selectedRoutineType = this.routineTypes.find(t => t.id === state.selectedRoutineTypeId) || this.selectedRoutineType;
            }

            // Restore Times
            this.greenTime = state.greenTime ?? this.greenTime;
            this.yellowTime = state.yellowTime ?? this.yellowTime;
            this.redTime = state.redTime ?? this.redTime;
            this.colorTime = state.colorTime ?? this.colorTime;
            this.colorId = state.colorId ?? this.colorId;

            // Restore Routine
            if (state.routine) {
                this.routine = state.routine;
                if (this.table) this.table.renderRows();
            }

            this._changeDetectorRef.markForCheck();
        } catch (e) {
            console.warn('Failed to load state', e);
        }
    }

    ngOnInit(): void {
        this.initializeForms();
        this.initializeData();
        this.listenToWebSocket();
        this.selectedRoutineType = this.routineTypes.find(type => type.id === ROUTINE_TYPES[0].id);
        this.colorId = ESP_COLOR_AVAILABLES[0].id;
        this._breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall])
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(result => {
                this.deviceIsMd = !result.matches;
                if (!this.deviceIsMd && this.mobileView !== 'config') {
                    this.mobileView = 'field';
                }
                this._changeDetectorRef.detectChanges();
            });

        this.subscribeToDeviceStatus();
    }

    subscribeToDeviceStatus(): void {
        this._webSocketService.getDevicesStatus()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (devices) => {
                    this.devicesStatus = devices;
                    this._changeDetectorRef.markForCheck();
                },
                error: (err) => {
                    console.error('Error loading devices status:', err);
                }
            });
    }

    listenToWebSocket(): void {
        // Suscribirse al estado de conexión del WebSocket
        this._webSocketService.connectionStatus$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(isConnected => {
                this.wsConnected = isConnected;
                // Si se recuperó la conexión, resetear la bandera de fallo
                if (isConnected) {
                    this.connectionFailed = false;
                } else {
                    if (this.uuid) {
                        this.uuid = undefined;
                        this.routine = [];
                        Swal.fire({
                            title: 'Error',
                            text: 'La conexión con el servidor se perdió.',
                            icon: 'error',
                            width: '300px',
                            theme: this.isDarkTheme() ? 'dark' : 'light',
                            confirmButtonText: 'Aceptar',
                            customClass: {
                                confirmButton: 'my-custom-button'
                            },
                        });
                    }
                }
                this._changeDetectorRef.markForCheck();
                setTimeout(() => this._changeDetectorRef.detectChanges(), 0);
            });

        // Suscribirse a los mensajes del WebSocket
        this._webSocketService.messages$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((data: WsResponse<any>) => {
                // Detectar mensaje específico de fallo de conexión
                if (data?.meta?.type === 'connection_failed') {
                    this.connectionFailed = true;
                    this._changeDetectorRef.markForCheck();
                    return;
                }
                switch (data.meta.type) {
                    case 'manual_routine_response':
                        if (!data.error) {
                            if (this.uuid && this.uuid === data.data.uuid) {
                                break;
                            }
                            this.uuid = data.data.uuid;
                            this._changeDetectorRef.detectChanges();
                        } else {
                            switch (data.error.code) {
                                case 'DEV_4001':
                                    this.removeLastStep();
                                    break;
                                default:
                                    break;
                            }
                            Swal.fire({
                                title: 'Error',
                                text: data.error.message || 'No se pudo iniciar la rutina.',
                                icon: 'error',
                                width: '300px',
                                theme: this.isDarkTheme() ? 'dark' : 'light',
                                confirmButtonText: 'Aceptar',
                                customClass: {
                                    confirmButton: 'my-custom-button'
                                },
                            });
                            this._changeDetectorRef.detectChanges();
                        }
                        break;
                    case 'manual_step_complete':
                        if (!data.error) {
                            this.removeFinishStep();
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: data.error.message || 'Algo falló en la secuencia.',
                                icon: 'error',
                                width: '300px',
                                theme: this.isDarkTheme() ? 'dark' : 'light',
                                confirmButtonText: 'Aceptar',
                                customClass: {
                                    confirmButton: 'my-custom-button'
                                },
                            });
                            this._changeDetectorRef.detectChanges();
                        }
                        break;
                    case 'finder_result':
                        // Manejo de respuesta del finder
                        break;
                    case 'alert':
                        // Por ejemplo, mostrar una alerta
                        Swal.fire({
                            title: 'Alerta',
                            text: data.data.text || 'Se recibió una alerta del sistema.',
                            icon: 'info',
                            width: '300px',
                            theme: this.isDarkTheme() ? 'dark' : 'light',
                            confirmButtonText: 'Aceptar',
                            customClass: {
                                confirmButton: 'my-custom-button'
                            },
                        });
                        break;
                    case 'stop_routine_response':
                        if (!data.error) {
                            this.routine = [];
                            this.uuid = undefined;
                            this._changeDetectorRef.detectChanges();
                            Swal.fire({
                                title: 'Correcto',
                                text: 'Rutina detenida con éxito.',
                                icon: 'success',
                                width: '300px',
                                theme: this.isDarkTheme() ? 'dark' : 'light',
                                confirmButtonText: 'Aceptar',
                                customClass: {
                                    confirmButton: 'my-custom-button'
                                },
                            });
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: data.error.message || 'Algo falló al detener la rutina.',
                                icon: 'error',
                                width: '300px',
                                theme: this.isDarkTheme() ? 'dark' : 'light',
                                confirmButtonText: 'Aceptar',
                                customClass: {
                                    confirmButton: 'my-custom-button'
                                },
                            });
                            this.routine = [];
                            this.uuid = undefined;
                            this._changeDetectorRef.detectChanges();
                        }
                        break;
                    default:
                        console.warn('Mensaje no manejado del WS:', data);
                }
            });
    }

    initializeForms(): void {
        this.divisionForm = this._formBuilder.group({
            divisions: this._formBuilder.array([]),
        });
    }

    initializeData(): void {
        forkJoin([
            this._service.getClusters(),
            this._coachDevicesService.getDevices()
        ]).subscribe(([clusterData$, devices]) => {
            this.clusterData$ = clusterData$;
            this.devices = devices;
            this._changeDetectorRef.markForCheck();
            this.proceedAfterDataLoad();
        });

        combineLatest([
            this._service.typesDevices$.pipe(takeUntil(this._unsubscribeAll)),
            this._service.divisions$.pipe(takeUntil(this._unsubscribeAll)),
        ]).subscribe(([typesDevices, divisions]) => {
            this.typesDevices = typesDevices;
            this.typesDevicesForGrid = typesDevices.map(t => ({
                id: t.id,
                name: t.name,
                color: t.representative_color,
                image_url: t.image_url
            })
            )
            this.divisions = divisions;

            this._changeDetectorRef.markForCheck();
        });
    }

    proceedAfterDataLoad(): void {
        this.loadState();
        this.validateAndUnassignExpiredDevices();
        const divisionsCount: number = this.divisions.length;
        if (this.clusterData$.length == 0) {
            Swal.fire({
                title: "Error",
                text: "Favor de crear al menos un acomodo finalizado",
                icon: "error",
                width: '300px',
                theme: this.isDarkTheme() ? 'dark' : 'light',
                customClass: {
                    confirmButton: 'my-custom-button'
                },
            }).then(() => {
                this.navigateToParent();
                this._changeDetectorRef.markForCheck();
            });
            return;
        }

        if (this.selectedDivisions.length > 0) {
            this.filterClustersByDivisions();
        }
        else if (divisionsCount > 1) {
            this.openDivisionModal();
        }
        else if (divisionsCount == 1) {
            this.selectedDivisions = [this.divisions[0]];
            this.filterClustersByDivisions();
        }
        else {
            Swal.fire({
                title: "Error",
                text: "Necesitas tener asignada una división",
                icon: "error",
                width: '300px',
                theme: this.isDarkTheme() ? 'dark' : 'light',
                customClass: {
                    confirmButton: 'my-custom-button'
                }
            }).then(() => {
                this.navigateToParent();
                this._changeDetectorRef.markForCheck();
            });
        }
        this.isLoading = false;
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onImageLoad(event: any): void {
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Cambia entre las vistas de campo y configuración en dispositivos móviles
     * @param view - Vista a mostrar: 'field' o 'config'
     */
    setMobileView(view: 'field' | 'config'): void {
        this.mobileView = view;
        this._changeDetectorRef.detectChanges();
    }

    getTypeDevice(row: number, col: number): TypeDeviceSummary | null {
        return this.tableData[`${row}-${col}`] || null;
    }

    /**
     * Detecta si la aplicación está en modo oscuro
     */
    isDarkTheme(): boolean {
        return document.body.classList.contains('dark');
    }

    swalCRUDError(err, message: string): void {
        Swal.fire({
            title: 'Error',
            text: err?.message || message,
            icon: 'error',
            width: '300px',
            theme: this.isDarkTheme() ? 'dark' : 'light',
            confirmButtonText: 'Aceptar',
            customClass: {
                confirmButton: 'my-custom-button'
            },
        });
    }

    closeModal(): void {
        this.dialog.closeAll();
    }

    navigateToParent(): void {
        this._router.navigate(['../'], { relativeTo: this._activatedRoute });
    }

    private clearTableData(): void {
        this.tableData = {};
        this._changeDetectorRef.markForCheck();
    }

    // Este método se llama cuando se hace clic en una celda del grid para añadir un paso
    selectTypeDevice(row: number, col: number): void {
        const key = `${row}-${col}`;
        const device = this.tableData[key];

        if (!device) {
            return;
        }

        // Check if device is assigned
        const typeDevice = this.selectedCluster?.type_devices?.find(td => td.pivot?.position === key);
        if (!typeDevice?.selected_device_id) {
            this.openDeviceModalByPosition(key);
            return;
        }

        const allDevicesAssigned = this.selectedCluster?.type_devices?.every(td => !!td.selected_device_id);
        if (!allDevicesAssigned) {
            Swal.fire({
                icon: 'error',
                title: 'Asignación incompleta',
                text: 'Debes asignar todos los dispositivos antes de continuar.',
                width: '300px',
                theme: this.isDarkTheme() ? 'dark' : 'light',
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'my-custom-button'
                },
            });
            return;
        }

        if (!this.wsConnected) {
            Swal.fire({
                icon: 'error',
                title: 'Conexión perdida',
                text: 'Debes tener una conexión estable para continuar.',
                width: '300px',
                theme: this.isDarkTheme() ? 'dark' : 'light',
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'my-custom-button'
                },
            });
            return;
        }

        if (this.greenTime < 0.1 || this.yellowTime < 0.1 || this.redTime < 0.1) {
            Swal.fire({
                icon: 'error',
                title: 'Tiempos inválidos',
                text: 'Debes ingresar un valor mayor o igual a 0.1 en Verde, Amarillo y Rojo.',
                width: '300px',
                theme: this.isDarkTheme() ? 'dark' : 'light',
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'my-custom-button'
                },
            });
            return;
        }
        // La posición se invierte (col-row) para los pasos de rutina
        const positionInverse = `${col}-${row}`;

        try {
            // Obtener los seriales de los dispositivos asignados al acomodo que no son el seleccionado
            const otherDeviceIds = this.selectedCluster?.type_devices
                .filter(td => td.selected_device_id && td.pivot.id !== device.id)
                .map(td => td.selected_device_id);

            // Filtrar la lista de dispositivos y extraer los seriales
            const otherDevices = this.devices.filter(d => otherDeviceIds?.includes(d.id));
            // Extraer solo los seriales de los dispositivos
            const otherDeviceSerials = otherDevices.map(d => d.serial);
            this.other_devices = otherDeviceSerials;
            if (this.selectedRoutineType?.id === 1)
                this.routine.push({
                    id: device.id,
                    position: positionInverse,
                    g: this.greenTime,
                    y: this.yellowTime,
                    r: this.redTime,
                });
            else if (this.selectedRoutineType?.id === 2)
                this.routine.push({
                    id: device.id,
                    position: positionInverse,
                    c: this.colorTime,
                    color_id: this.colorId,
                });
            else {
                this.routine = [];
                return;
            }
            // Actualiza la celda actual seleccionada y aplica el estilo
            this.currentSelectedCell = { row, col };

            // Crear una nueva referencia del array para forzar la detección de cambios
            this.routine = [...this.routine];

            this.sendManualRoutine();

            // Forzar la actualización de la tabla
            setTimeout(() => {
                if (this.table) {
                    this.table.renderRows();
                }
                this._changeDetectorRef.markForCheck();
                this._changeDetectorRef.detectChanges();
            }, 0);
            this.saveState();
        } catch (error) {
            console.error('Error al agregar paso:', error);
        }
    }

    onClusterChange(clusterId: number): void {
        const cluster = this.clusterData$.find(cluster => cluster.id === clusterId);

        if (cluster) {
            // Limpiar dispositivos asignados previamente
            cluster.type_devices.forEach(td => {
                td.selected_device_id = null;
            });

            this.selectedCluster = cluster;
            this.routine = [];
            this.loadTableData(this.selectedCluster.id);
        }

        this.saveState();
        this._changeDetectorRef.markForCheck();
    }

    loadTableData(clusterId?: number): void {
        this.tableData = {};
        const clusterData = this.filteredClusterData$.find(cluster => cluster.id === clusterId);
        if (clusterData) {
            clusterData.type_devices.forEach(type_device => {
                const key = `${type_device.pivot.position}`;
                const typeDevice = clusterData.type_devices.find(td => td.pivot.position === key);

                if (typeDevice) {
                    this.tableData[key] = {
                        id: typeDevice.pivot.id,
                        name: typeDevice.name,
                        color: typeDevice.representative_color,
                        image_url: typeDevice.image_url
                    };
                }
            });
        }
        this._changeDetectorRef.markForCheck();
    }

    openDivisionModal(): void {
        if (!this.divisionModal) {
            console.error('Division modal template is missing!');
            return;
        }
        const dialogRef = this.dialog.open(this.divisionModal);

        dialogRef.afterClosed().subscribe(result => {
            if (!this.selectedDivisions.length) {
                Swal.fire({
                    title: "Error",
                    text: "Necesitas tener asignada una división",
                    icon: "error",
                    width: '300px',
                    theme: this.isDarkTheme() ? 'dark' : 'light',
                    customClass: {
                        confirmButton: 'my-custom-button'
                    },
                }).then(() => {
                    this.navigateToParent();
                    this._changeDetectorRef.markForCheck();
                });
            } else {
                this.filterClustersByDivisions();
            }
        });
    }

    filterClustersByDivisions(): void {
        const selectedDivisionIds = this.selectedDivisions.map(division => division.id);

        console.log('Filtering clusters. Selected Divisions:', selectedDivisionIds);
        console.log('Total clusters available:', this.clusterData$.length);

        // Log de todos los clusters con sus divisiones
        this.clusterData$.forEach(cluster => {
            const clusterDivisionIds = cluster.divisions?.map(d => d.id) || [];
            console.log(`Cluster "${cluster.name}" (id: ${cluster.id}) has divisions:`, clusterDivisionIds);
        });

        // Filtrar clusters según las divisiones seleccionadas
        // El cluster debe contener TODAS las divisiones seleccionadas
        this.filteredClusterData$ = this.clusterData$.filter(cluster => {
            const clusterDivisionIds = cluster.divisions?.map(division => division.id) || [];

            // Verificar que el cluster tenga todas las divisiones seleccionadas
            const hasAllSelectedDivisions = selectedDivisionIds.every(id => clusterDivisionIds.includes(id));

            console.log(`Cluster "${cluster.name}": divisions [${clusterDivisionIds}], selected [${selectedDivisionIds}], matches: ${hasAllSelectedDivisions}`);
            return hasAllSelectedDivisions;
        });

        console.log('Filtered clusters count:', this.filteredClusterData$.length);
        console.log('Filtered clusters:', this.filteredClusterData$.map(c => c.name));

        if (this.filteredClusterData$.length === 0) {
            this.selectedCluster = null;
            this.clearTableData();
        } else {
            // Solo accede al id si selectedCluster no es null
            const currentClusterFound = this.selectedCluster
                ? this.filteredClusterData$.find(c => c.id === this.selectedCluster.id)
                : null;

            if (!currentClusterFound) {
                this.selectedCluster = this.filteredClusterData$[0];
            }

            // Asegúrate de que selectedCluster esté definido antes de llamar a loadTableData
            if (this.selectedCluster) {
                this.loadTableData(this.selectedCluster.id);
            }
        }

        this._changeDetectorRef.markForCheck();
    }

    toggleDivision(division: Division, event: any): void {
        const divisionsArray = this.divisionForm.get('divisions') as UntypedFormArray;

        if (event.checked) {
            // Verificar si la división ya existe antes de agregarla
            const exists = divisionsArray.controls.some(ctrl => ctrl.value === division.id);
            if (!exists) {
                divisionsArray.push(this._formBuilder.control(division.id));
            }
        } else {
            // Eliminar TODAS las ocurrencias de esta división (en caso de duplicados)
            let index = divisionsArray.controls.findIndex(ctrl => ctrl.value === division.id);
            while (index !== -1) {
                divisionsArray.removeAt(index);
                index = divisionsArray.controls.findIndex(ctrl => ctrl.value === division.id);
            }
        }

        this._changeDetectorRef.markForCheck();
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    isDivisionSelected(divisionId: number): boolean {
        const divisionsArray = this.divisionForm.get('divisions') as UntypedFormArray;
        return divisionsArray.controls.some(ctrl => ctrl.value === divisionId);
    }

    // Este método se llama cuando cambia cualquiera de los campos de tiempo en la tabla
    onTimeChange(element: any, field: 'g' | 'y' | 'r' | 'time'): void {
        try {
            if (element[field] < 0 || element[field] === null || element[field] === '') {
                element[field] = 1;
            }
        } catch (error) {
            console.error('Error en onTimeChange:', error);
        }

        // Siempre forzar detección de cambios
        this.saveState();
        this._changeDetectorRef.markForCheck();
    }

    // Validador para asegurar que al menos un método de generación esté seleccionado
    atLeastOneGenerationMethod(): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const generateAutomatically = group.get('generate_automatically')?.value;
            const generateManually = group.get('generate_manually')?.value;

            return generateAutomatically || generateManually ? null : { 'noGenerationMethodSelected': true };
        };
    }

    closeDivisionModal(): void {
        const divisionsArray = this.divisionForm.get('divisions') as UntypedFormArray;
        console.log('closeDivisionModal - FormArray values (before cleanup):', divisionsArray.value);

        // Eliminar duplicados del FormArray
        const uniqueIds = [...new Set(divisionsArray.value)];
        divisionsArray.clear();
        uniqueIds.forEach(id => divisionsArray.push(this._formBuilder.control(id)));

        console.log('closeDivisionModal - FormArray values (after cleanup):', divisionsArray.value);

        this.selectedDivisions = divisionsArray.controls
            .map(control => this.divisions.find(division => division.id === control.value))
            .filter(d => !!d) as Division[];

        console.log('closeDivisionModal - selectedDivisions after update:', this.selectedDivisions.map(d => d.id));

        this.filterClustersByDivisions();
        this.saveState();
        this.dialog.closeAll();
    }

    reversePosition(position: string): string {
        if (!position) return '';
        const [x, y] = position.split('-');
        return `${y}-${x}`;
    }

    removeFinishStep(): void {
        //removemos el primer elemento del array routine
        this.routine.shift();

        this.routine = [...this.routine];

        if (this.routine.length === 0) {
            this.uuid = undefined;
        }

        if (this.table) {
            this.table.renderRows();
        }
        this.saveState();
        this._changeDetectorRef.detectChanges();
    }

    removeLastStep(): void {
        this.routine.pop();
        this.routine = [...this.routine];
        this.saveState();
        this._changeDetectorRef.detectChanges();
    }

    async sendManualRoutine() {
        const payload: any = {};
        payload.training = this.routine.map(r => ({
            id: r.id,
            serial: this.devices.find(d => d.id === this.selectedCluster?.type_devices.find(td => td.pivot.id === r.id)?.selected_device_id)?.serial,
            g: r.g,
            y: r.y,
            r: r.r,
            c: r.c,
            color_id: r.color_id,
        }));
        if (this.uuid) {
            payload.uuid = this.uuid;
        }
        payload.routine_type_id = this.selectedRoutineType?.id;
        payload.other_devices = this.other_devices;
        const data = { type: 'manual_routine', payload };
        this._webSocketService.sendMessage(data);
    }

    async stopRoutine() {
        if (!this.uuid) return;
        const data = { type: 'stop_routine', routine_log_id: this.uuid };
        this._webSocketService.sendMessage(data);
    }

    onRoutineTypeChange(routineTypeId: number): void {
        this.selectedRoutineType = this.routineTypes.find(type => type.id === routineTypeId);
        this.saveState();
    }

    /**
     * Recarga la página para intentar establecer una nueva conexión WebSocket
     */
    reloadPage(): void {
        window.location.reload();
    }

    // ==================== Device Assignment ====================

    onCellRightClick(event: { row: number, col: number, event: MouseEvent }): void {
        event.event?.preventDefault();

        const position = `${event.row}-${event.col}`;
        const typeDevice = this.selectedCluster?.type_devices?.find(td => td.pivot?.position === position);

        if (typeDevice) {
            this.openDeviceModalByPosition(position);
        }
    }

    openDeviceModalByPosition(position: string): void {
        const typeDevice = this.selectedCluster?.type_devices?.find(td => td.pivot?.position === position);

        if (!typeDevice) return;

        this.modalPosition = position;
        this.modalCurrentDeviceId = typeDevice.selected_device_id ?? null;

        // Create a mock routine object for the service
        const mockRoutine: any = { cluster: this.selectedCluster };

        this.availableDevices = this._deviceAssignmentService.getAvailableDevices(
            typeDevice.id,
            this.devices,
            [mockRoutine],
            typeDevice.selected_device_id
        );

        this.availableDevices = this._deviceAssignmentService.sortDevicesWithSelectedFirst(
            this.availableDevices,
            this.modalCurrentDeviceId
        );

        this.openDeviceModal();
    }

    private openDeviceModal(): void {
        const dialogRef = this.dialog.open(RoutineDetonatorDeviceModalComponent, {
            width: '100%',
            maxWidth: '450px',
            height: '600px',
            panelClass: 'device-modal-panel',
            data: {
                availableDevices: this.availableDevices,
                currentDeviceId: this.modalCurrentDeviceId
            },
            disableClose: true
        });

        dialogRef.componentInstance.finderRequest.subscribe((deviceId: number) => {
            this.sendFinderByDeviceId(deviceId);
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result) return;

            if (result.action === 'assign') {
                this.assignDeviceToPosition(result.deviceId);
            } else if (result.action === 'unassign') {
                this.unassignDeviceFromPosition();
            }
        });
    }

    assignDeviceToPosition(deviceId: number): void {
        if (!this.modalPosition || !this.selectedCluster) return;

        const typeDeviceIndex = this.selectedCluster.type_devices.findIndex(td => td.pivot.position === this.modalPosition);
        if (typeDeviceIndex !== -1) {
            this.selectedCluster.type_devices[typeDeviceIndex].selected_device_id = deviceId;
            // Create new reference for type_devices to trigger change detection
            this.selectedCluster.type_devices = [...this.selectedCluster.type_devices];
            // Create new reference for selectedCluster to trigger change detection in child components
            this.selectedCluster = { ...this.selectedCluster };

            this.saveState();
            this._changeDetectorRef.markForCheck();
            this._changeDetectorRef.detectChanges();
        }
    }

    unassignDeviceFromPosition(): void {
        if (!this.modalPosition || !this.selectedCluster) return;

        const typeDeviceIndex = this.selectedCluster.type_devices.findIndex(td => td.pivot.position === this.modalPosition);
        if (typeDeviceIndex !== -1) {
            this.selectedCluster.type_devices[typeDeviceIndex].selected_device_id = null;
            // Create new reference for type_devices to trigger change detection
            this.selectedCluster.type_devices = [...this.selectedCluster.type_devices];
            // Create new reference for selectedCluster to trigger change detection in child components
            this.selectedCluster = { ...this.selectedCluster };

            this._changeDetectorRef.markForCheck();
            this._changeDetectorRef.detectChanges();
        }
    }

    async sendFinderByDeviceId(deviceId: number): Promise<void> {
        const device = this.devices.find(d => d.id === deviceId);

        if (!device?.serial) {
            Swal.fire({
                title: 'Error',
                text: 'No se encontró el dispositivo o no tiene serial',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        const instruction = { type: 'finder', uid: device.serial };
        this._webSocketService.sendMessage(instruction);

        try {
            const response = await firstValueFrom(this._webSocketService.messages$.pipe(take(1)));
            if (response.meta.type === 'finder_response' && response.error) {
                Swal.fire({
                    title: 'Error',
                    text: response.error.message || 'No se pudo encontrar el dispositivo',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    validateAndUnassignExpiredDevices(): void {
        if (!this.selectedCluster || !this.selectedCluster.type_devices) return;

        let changed = false;
        this.selectedCluster.type_devices.forEach(td => {
            if (td.selected_device_id) {
                const device = this.devices.find(d => d.id === td.selected_device_id);
                if (device) {
                    if (!this._deviceAssignmentService.isDeviceValid(device)) {
                        td.selected_device_id = null;
                        changed = true;
                    }
                }
            }
        });

        if (changed) {
            this.selectedCluster.type_devices = [...this.selectedCluster.type_devices];
            this.selectedCluster = { ...this.selectedCluster };

            // Update the cluster in filteredClusterData$ so loadTableData sees the changes
            const index = this.filteredClusterData$.findIndex(c => c.id === this.selectedCluster.id);
            if (index !== -1) {
                this.filteredClusterData$[index] = this.selectedCluster;
                // Also update the main clusterData$ array if needed, though loadTableData uses filtered
                const mainIndex = this.clusterData$.findIndex(c => c.id === this.selectedCluster.id);
                if (mainIndex !== -1) {
                    this.clusterData$[mainIndex] = this.selectedCluster;
                }
            }

            this.saveState();
            this.loadTableData(this.selectedCluster.id);
            this._changeDetectorRef.markForCheck();
            Swal.fire({
                title: 'Aviso',
                text: 'Se han desasignado dispositivos con licencia vencida o inválida.',
                icon: 'warning',
                width: '300px',
                theme: this.isDarkTheme() ? 'dark' : 'light',
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'my-custom-button'
                },
            });
        }
    }
}
